import { callProcedure } from 'clickNgo/helpers/api'

export type SobActualsReviewPayload = {
  PartnerId: string
  FYear: number
  ProgramTypes: string
  Category: string
  SubCategory: string
  L3Category: string | null
  IsNoPlan: number
  IsNoPlanContractual: number
  SobActualPYQ1: number | null
  SobActualPYQ2: number | null
  SobActualPYQ3: number | null
  SobActualPYQ4: number | null
  SobActualCYQ1: number | null
  SobActualCYQ2: number | null
  SobActualCYQ3: number | null
  SobActualCYQ4: number | null
}

export type ApplySobActualsReviewParams = {
  partnerId: string
  fYear: number
  sob: SobActualsReviewPayload[]
}

export const applySobActualsReview = async ({
  partnerId,
  fYear,
  sob,
}: ApplySobActualsReviewParams): Promise<void> => {
  const response = await callProcedure({
    url: '/webservice/621/sp/v3/spJBPPlanningApplyChangesSob/call',
    method: 'POST',
    data: {
      'p.PartnerID': partnerId,
      'p.Fyear': fYear,
      'p.Sob': JSON.stringify(sob),
    },
  })

  if ('error' in response) {
    throw response.error
  }
}
